var render = function render(_c,_vm){return _c('div',[(_vm.props.rowValue != null && _vm.props.rowValue != '1753-01-01T00:00:00')?_c('span',{style:({
      color: _vm.$options.colorDate(_vm.props.row[_vm.props.column], _vm.props)
        ? 'green'
        : 'red'
    })},[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.$options.setFormatDate(_vm.props))+" ")]):_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }